import React, { useState } from "react"
import dayjs from "dayjs"
import { Link } from "react-router-dom"
import UseallOverview from "../Componentslogic/UseAlloverview"
import "../../Styles/MobileViewstyles.css" // Make sure to include/update your CSS file

const MobileDineInPage = () => {
  const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"))
  const [selectedFilter, setSelectedFilter] = useState("All")
  const [searchQuery, setSearchQuery] = useState("")
  const {
    data: deliveryData,
    loading,
    hasMore,
    nextPage,
  } = UseallOverview("Orders", startDate, endDate)
  const getStatus = (order) => {
    if (order.Done) return { text: "Done", className: "Delivered" }
    if (order.Confirmed) return { text: "Confirmed", className: "fulfilled" }
    if (!order.Confirmed) return { text: "Placed", className: "pending" }
    return { text: "Unknown", className: "Unknown" }
  }
  const filteredData = deliveryData.filter((order) => {
    const { text } = getStatus(order)
    const matchesSearch =
      !searchQuery || order.orderNumber.includes(searchQuery)
    const matchesFilter = selectedFilter === "All" || text === selectedFilter
    return matchesSearch && matchesFilter
  })

  const formatTimestamp = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "N/A"
    const date = new Date(timestamp.seconds * 1000)
    return `${date.toLocaleDateString()} at ${date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`
  }

  return (
    <div className="mobile-dashboard-container">
      {/* Filters at the Top */}
      <div className="mobile-date-filters d-flex justify-content-around mt-4 mb-4">
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="start-date" className="mb-2">
            Start Date
          </label>
          <input
            id="start-date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="mobile-date-input"
          />
        </div>
        <div className="d-flex flex-column align-items-center">
          <label htmlFor="end-date" className="mb-2">
            End Date
          </label>
          <input
            id="end-date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="mobile-date-input"
          />
        </div>
      </div>
      <div className="mobile-orders-container mt-4">
        {["All", "Placed", "Confirmed", "Done"].map((filter) => (
          <div
            key={filter}
            className={`mobile-filter-card ${
              selectedFilter === filter ? "active" : ""
            }`}
            onClick={() => setSelectedFilter(filter)}
          >
            {filter === "All" ? "All Orders" : filter}
          </div>
        ))}
      </div>
      <div className="mobile-search-container mb-4">
        <input
          type="text"
          placeholder="Search by order number..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="mobile-search-input"
        />
      </div>

      {/* Orders as Cards in a Horizontal Scroll Container */}
      <div className="mobile-orders-container">
        {filteredData.map((order, index) => {
          const orderDate =
            order.createdAt && order.createdAt.toDate
              ? order.createdAt.toDate()
              : new Date(order.createdAt) // Use .toDate() for Firebase Timestamp

          const updatedDate =
            order.updatedAt && order.updatedAt.toDate
              ? order.updatedAt.toDate()
              : new Date(order.updatedAt)

          // Extract time
          const orderTime = orderDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })

          const updatedTime = updatedDate.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })
          const { text, className } = getStatus(order)

          return (
            <div key={index} className="mobile-order-card">
              <p>
                <strong>Order:</strong> {order.ordernumber}
              </p>
              <p>
                <strong>Date:</strong> {orderTime}
              </p>
              <p>
                <strong>Customer:</strong> {order.userName}
              </p>
              <p>
                <strong>Total:</strong> {order.totalAmount.toFixed(2)} EGP
              </p>
              <p>
                <strong>Status:</strong>{" "}
                <span className={`status ${className}`}>{text}</span>
              </p>
              <div className="d-flex justify-content-center mt-5">
                <Link to={`/adminorderdetails/${order.id}`}>
                  <button className="mobile-view-btn">View</button>
                </Link>
              </div>
            </div>
          )
        })}
      </div>

      {/* Load More Button */}
      {hasMore && !loading && (
        <div className="mobile-load-more">
          <button onClick={() => nextPage()} className="mobile-load-more-btn">
            Load More
          </button>
        </div>
      )}
      {loading && <p>Loading...</p>}
    </div>
  )
}

export default MobileDineInPage
